import { VStack } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import Face from './Face';
import FACES from '../../constants/faces';

function FacesInput({ content, onAdd, onSub }) {
  return (
    <VStack>
      {FACES.map((face) => (
        <Face
          key={face.index}
          face={face}
          onAdd={() => onAdd(face.index)}
          onSub={() => onSub(face.index)}
          quantity={content[face.index]}
        />
      ))}
    </VStack>
  );
}

FacesInput.propTypes = {
  content: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onSub: PropTypes.func.isRequired,
};

export default FacesInput;
